module.exports = __webpack_public_path__ + "static/media/__there-is-nothing-here.06d48409.svg";